export const iconFontAwesomeSciencePills = (
	<i className="fa-solid fa-pills"></i>
);
